import * as angular from 'angular';
import { MODULE_NAME } from '../../config/constants';

import FdxDisablePasteDirective from './fdx-disable-paste.directive.js';

angular.module(MODULE_NAME)
  .directive('fdxDisablePaste', FdxDisablePasteDirective);